<app-table-column name="position" size="smallest">
  <div content>
    <span>
      {{ formattedPosition || '---' }}
    </span>
  </div>
</app-table-column>

<app-table-column name="name" size="medium">
  <span content>{{ item.name || item.description || '---' }}</span>
</app-table-column>

<app-table-column name="sku" size="small">
  <span content>{{ item.sku || '---' }}</span>
</app-table-column>

<app-table-column name="quantity" size="smallest">
  <span content>{{ item.quantity != null ? item.quantity : 0 }}</span>
</app-table-column>
